<template>
    <div class="seller-order-distributor">
        <div class="common-header-wrap">
            <mt-header title="配送员列表" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <!-- header -->
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="distributor-list" v-if="distributorList.length > 0">
                    <div class="distributor-item" v-for="(item, index) in distributorList" :key="item.o2o_distributor_id">
                    <div class="left"><img :src="item.o2o_distributor_avatar"><i class="receipt-state"></i></div>
                    <div class="right">
                        <div class="distributor-name"> {{item.o2o_distributor_name}}</div>
                        <div class="distributor-static">
                            <div class="static">

                                <div class="order-count">等待<i> {{item.count_wait}}</i>单</div>
                                </div>
                            <div class="static">

                                <div class="order-count">完成<i> {{item.count_complete}}</i>单</div>
                                </div>
                            </div>
                        </div>
                    <div class="distributor-btn">
                        <!--<a class="btn1" @click="markerPosition(item.o2o_distributor_id)">定位</a>-->
                        <a class="btn2" @click="deliverOrder(item)">指派</a>
                        </div>
                    </div>
            </div>
            <empty-record v-else-if="distributorList && !distributorList.length"></empty-record>
        </div>

    </div>
</template>

<script>
import { getDistributorList, deliverOrder } from '../../../api/sellerOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'

import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  name: 'SellerOrderDistributor',
  data () {
    return {
      order_id: this.$route.query.order_id,
      distributorList: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },

  mounted () {
  },
  computed: {

  },
  created: function () {

  },

  methods: {
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getDistributorList(true)
      }
    },
    getDistributorList (ispush) {
      Indicator.open()
      let params = this.params
      getDistributorList(params, this.order_id).then(res => {
        Indicator.close()

        if (ispush && this.distributorList) {
          this.distributorList = this.distributorList.concat(res.result.distributor_list)
        } else {
          this.distributorList = res.result.distributor_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    deliverOrder (o2oDistributor) {
      deliverOrder(this.order_id, o2oDistributor.o2o_distributor_id).then(res => {
        this.$router.go(-1)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
    .seller-order-distributor .distributor-list .distributor-item{overflow:hidden;border-bottom:1px solid #eee;padding-bottom:0.5rem}
    .seller-order-distributor .distributor-list .distributor-item .left{float:left;width:2.5rem;padding-left:0.5rem;padding-top:0.5rem;position:relative;}
    .seller-order-distributor .distributor-list .distributor-item .left img{width:2.5rem;height:2.5rem;border-radius:50%;}
    .seller-order-distributor .distributor-list .distributor-item .left i{position:absolute;width:0.4rem;height:0.4rem;display:block;border-radius:50%;right:0.2rem;bottom:0.2rem;background-color:#dcdcdc}
    .seller-order-distributor .distributor-list .distributor-item .right{float:left;width:180px;padding:0.5rem;margin-top:0.25rem}
    .seller-order-distributor .distributor-list .distributor-item .distributor-btn{float:right;width:1.4rem;margin-right:0.5rem;text-align:right;padding-top:0.5rem;}
    .seller-order-distributor .distributor-list .distributor-item .distributor-static{overflow:hidden;}
    .seller-order-distributor .distributor-list .distributor-item .distributor-static .static{float:left;width:50%;}
    .seller-order-distributor .distributor-list .distributor-item  .distributor-name{font-size:0.7rem;line-height:1rem;}
    .seller-order-distributor .distributor-list .distributor-item  .static{color:#999;font-size:0.6rem;line-height:1rem;}
    .seller-order-distributor .distributor-list .distributor-item  .order-count i{font-size:0.7rem;font-weight:700;margin:0 0.1rem;color:$primaryColor}
    .seller-order-distributor .distributor-list .distributor-item  .btn1{color: #0579C6;display:none}
    .seller-order-distributor .distributor-list .distributor-item[data-state='1']  .btn1{display:block}
    .seller-order-distributor .distributor-list .distributor-item  .btn2{color: #F60;font-size:.7rem}
    .seller-order-distributor .distributor-list .distributor-more{padding:1rem 0;text-align:center;color:#999;position:absolute;bottom:0;left:0;width:100%;background:#fff}
    .seller-order-distributor .distributor-list .distributor-item.select{background:#d9ebff}
    .seller-order-distributor .distributor-list .distributor-item[data-state='1'][data-receipt='0'] .left i{background:#e84343}
    .seller-order-distributor .distributor-list .distributor-item[data-state='1'][data-receipt='1'] .left i{background:#76e06b}
</style>
